import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  acalandPricingForm: any;
  acadesignPricingForm: any;
  acafmPricingForm: any;

  acalandProjectDataSet: {key: string, area: number, fee: number}[] = [
    {key: 'Basic land surveying', area: 1000, fee: 4},
    {key: 'Small scale subdivision', area: 10000, fee: 5},
    {key: 'Medium scale subdivision', area: 10000, fee: 6},
    {key: 'Large scale subdivision', area: 30000, fee: 6.5}
  ];
  acadesignProjectDataSet: {key: string, gfa: number, fee: number}[] = [
    {key: 'Residential architectural design', gfa: 250, fee: 5},
    {key: 'Multi-storey building architectural design', gfa: 2500, fee: 1},
    {key: 'Engineering services for commercial buildings', gfa: 600, fee: 1},
  ];
  acafmProjectDataSet: {key: string, ufa: number, mcprav: number, ravpa: number}[] = [
    {key: 'Single-storey dwelling', ufa: 200, mcprav: 2, ravpa: 2500},
    {key: 'Large single-storey building', ufa: 10000, mcprav: 3, ravpa: 2100},
    {key: 'Multi-units townhouses', ufa: 1000, mcprav: 3, ravpa: 2200},
    {key: '100-room retirement village', ufa: 7000, mcprav: 3, ravpa: 1800},
    {key: '100 units multi-storey apartment', ufa: 7000, mcprav: 2, ravpa: 2000},
    {key: 'Small education facilities', ufa: 10000, mcprav: 3, ravpa: 1000},
    {key: 'Medium education facilities', ufa: 30000, mcprav: 4, ravpa: 1000},
    {key: 'Large education facilities', ufa: 50000, mcprav: 4, ravpa: 1000}
  ];

  constructor() { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.acalandPricingForm = new FormGroup({
      acalandProjectType: new FormControl(null),
      landSize: new FormControl(null),
      consultantFee: new FormControl(null),
      developmentCost: new FormControl(null),
      tangibleSaving: new FormControl(10),
      intangibleSaving: new FormControl(12),
      shareOfSavings: new FormControl(50),
      acalandProjectPricing: new FormControl(null)
    });
    this.acalandPricingForm.get('acalandProjectType').valueChanges.subscribe((val: any) => {
      const landSize = this.acalandPricingForm.get('acalandProjectType').value.area;
      this.acalandPricingForm.get('landSize').patchValue(landSize);
      const consultantFeePercent = this.acalandPricingForm.get('acalandProjectType').value.fee;
      this.acalandPricingForm.get('consultantFee').patchValue(consultantFeePercent);
      this.calcAcalandPricing();
    });
    this.acadesignPricingForm = new FormGroup({
      acadesignProjectType: new FormControl(null),
      gfa: new FormControl(null),
      consultantFee: new FormControl(null),
      constructionCostPa: new FormControl(3000),
      tangibleSaving: new FormControl(8),
      intangibleSaving: new FormControl(10),
      shareOfSavings: new FormControl(50),
      acadesignProjectPricing: new FormControl(null)
    });
    this.acadesignPricingForm.get('acadesignProjectType').valueChanges.subscribe((val: any) => {
      const gfa = this.acadesignPricingForm.get('acadesignProjectType').value.gfa;
      this.acadesignPricingForm.get('gfa').patchValue(gfa);
      this.calcAcadesignPricing();
    });
    this.acafmPricingForm = new FormGroup({
      acafmProjectType: new FormControl(null),
      ufa: new FormControl(null),
      mcprav: new FormControl(null),
      ravpa: new FormControl(null),
      rav: new FormControl(null),
      mc: new FormControl(null),
      tangibleSaving: new FormControl(0.1),
      intangibleSaving: new FormControl(0.2),
      shareOfSavings: new FormControl(15),
      acafmProjectPricing: new FormControl(null)
    });
    this.acafmPricingForm.get('acafmProjectType').valueChanges.subscribe((val: any) => {
      const ufa = this.acafmPricingForm.get('acafmProjectType').value.ufa;
      this.acafmPricingForm.get('ufa').patchValue(ufa);
      const mcprav = this.acafmPricingForm.get('acafmProjectType').value.mcprav;
      this.acafmPricingForm.get('mcprav').patchValue(mcprav);
      const ravpa = this.acafmPricingForm.get('acafmProjectType').value.ravpa;
      this.acafmPricingForm.get('ravpa').patchValue(ravpa);
      this.calcAcafmPricing();
    });
  }

calcAcalandPricing(): void {
  const landSize = this.acalandPricingForm.get('landSize').value;
  const consultantFeePercent = this.acalandPricingForm.get('acalandProjectType').value.fee;
  const developmentCost = 8605.338 * Math.pow(landSize, 0.2747166);
  this.acalandPricingForm.get('developmentCost').patchValue(developmentCost.toFixed(2));
  const consultantFee = developmentCost * consultantFeePercent / 100;
  this.acalandPricingForm.get('consultantFee').patchValue(consultantFee.toFixed(2));
  const tangibleSaving = this.acalandPricingForm.get('tangibleSaving').value / 100 * consultantFee;
  const intangibleSaving = this.acalandPricingForm.get('intangibleSaving').value / 100 * consultantFee;
  const acalandProjectPrice = (this.acalandPricingForm.get('shareOfSavings').value / 100) * (tangibleSaving + intangibleSaving);
  this.acalandPricingForm.get('acalandProjectPricing').patchValue(acalandProjectPrice.toFixed(2));
}

  calcAcadesignPricing(): void {
    const gfa = this.acadesignPricingForm.get('gfa').value;
    const consultantFeePercent = this.acadesignPricingForm.get('acadesignProjectType').value.fee;
    const constructionCost = this.acadesignPricingForm.get('constructionCostPa').value * gfa;
    const consultantFee = constructionCost * consultantFeePercent / 100;
    this.acadesignPricingForm.get('consultantFee').patchValue(consultantFee.toFixed(2));
    const tangibleSaving = this.acadesignPricingForm.get('tangibleSaving').value / 100 * consultantFee;
    const intangibleSaving = this.acadesignPricingForm.get('intangibleSaving').value / 100 * consultantFee;
    const acadesignProjectPrice = (this.acadesignPricingForm.get('shareOfSavings').value / 100) * (tangibleSaving + intangibleSaving);
    this.acadesignPricingForm.get('acadesignProjectPricing').patchValue(acadesignProjectPrice.toFixed(2));
  }

  calcAcafmPricing(): void {
    const ufa = this.acafmPricingForm.get('ufa').value;
    const mcprav = this.acafmPricingForm.get('mcprav').value / 100;
    const ravpa = this.acafmPricingForm.get('ravpa').value;
    const rav = ravpa * ufa;
    this.acafmPricingForm.get('rav').patchValue(rav.toFixed(0));
    const mc = mcprav * rav;
    this.acafmPricingForm.get('mc').patchValue(mc.toFixed(0));
    const tangibleSaving = mc - (rav * (mcprav - this.acafmPricingForm.get('tangibleSaving').value / 100));
    const intangibleSaving = rav * this.acafmPricingForm.get('intangibleSaving').value / 100;
    const acafmProjectPrice = (this.acafmPricingForm.get('shareOfSavings').value / 100) * (tangibleSaving + intangibleSaving);
    this.acafmPricingForm.get('acafmProjectPricing').patchValue(acafmProjectPrice.toFixed(2));
  }

}
